module.exports = __webpack_public_path__ + "img/gs-img-4_ja.9ea69dfd.png";